import * as s from './link.styles';
// eslint-disable-next-line
import { jsx } from '@emotion/react';
import { css } from '@emotion/react';
export const Link = ({ label, leftIcon, rightIcon, url, openUrlInNewTab, size = 'small', underline = false, marginTop = '20px', marginBottom = '20px', }) => {
    return (jsx("a", { href: url, "data-qa": "link-url", target: openUrlInNewTab ? '_blank' : '_self', rel: "noopener noreferrer", 
        // eslint-disable-next-line
        css: [
            css `
          margin-top: ${marginTop};
          margin-bottom: ${marginBottom};
        `,
            s.link({ size }),
        ] },
        jsx("div", { 
            // eslint-disable-next-line
            css: [s.cursor, s.linkContainer({ size })] },
            leftIcon,
            jsx("span", { 
                // eslint-disable-next-line
                css: s.linkLabel({ underline }) }, label),
            rightIcon)));
};
